(function () {
    const config = JSON.parse(
        document.querySelector('[data-gift-options-config]').innerHTML
    );
    const cartDrawer = document.getElementById('CartDrawer');

    if (!config || !cartDrawer) {
        return;
    }

    function getCartLineItemsByHandle(cart, handle) {
        return cart.items.filter(item => item.handle === handle);
    }

    function removeCartItemsByHandle(cart, handle, sections = null) {
        return new Promise((resolve, reject) => {
            const itemsToRemove = cart.items.filter(item => item.handle === handle);
            if (!itemsToRemove.length) {
                resolve({cart, hasCartChanged: false});

                return;
            }

            const updates = {};
            itemsToRemove.forEach(item => updates[item.key] = 0);

            const body = {updates};

            if (sections) {
                body.sections = sections;
                body.sections_url = BryanAnthonys.pagePath();
            }

            BryanAnthonys.cart.update(JSON.stringify(body))
                .then(cart => resolve({cart, hasCartChanged: true}))
                .catch(reject);
        });
    }

    class GiftPackaging extends HTMLElement {
        connectedCallback() {
            this.settings = config.giftPackaging;

            if (!this.settings.productHandle) {
                return;
            }

            this.cart = BryanAnthonys.cart.getCache();

            if (GiftPackaging.canBeShown(this.cart)) {
                this.render();

                if (!this.dataset.inModal) {
                    cartDrawer.querySelector('cart-items').classList.add('hide-gift-packaging');
                }
            }

            this.addEventListener('change', this.updateGiftPackaging.bind(this));
        }

        static canBeShown(cart) {
            const itemsBlackListed = cart.items.filter(
                item => config.giftPackaging.productTypeHardBlacklist.indexOf(item.product_type) === 0
            );

            if (itemsBlackListed.length !== 0) {
                return false;
            }

            const itemsNotBlackListed = cart.items.filter(
                item => config.giftPackaging.productTypeBlacklist.indexOf(item.product_type) === -1
            );

            return itemsNotBlackListed.length !== 0;
        }

        updateGiftPackaging(event) {
            event.stopPropagation();
            const checkbox = event.target;
            const variantId = checkbox.checked ? checkbox.value : null;
            checkbox.checked = !checkbox.checked;
            checkbox.classList.add('loading');
            checkbox.disabled = true;

            const handleCartChangeError = error => {
                console.error('Error when updating gift packaging', error);

                checkbox.classList.remove('loading');
                checkbox.disabled = false;

                const message = `
                    An error occurred. Please refresh the page and try again.
                    We apologize for the inconvenience.
                    If the problem persists, please get in touch with customer service.
                `;
                BryanAnthonys.showToast(message.trim(), 'error');
            };

            if (variantId) {
                const addGiftPackagingToCart = () => {
                    return new Promise((resolve, reject) => {
                        const items = [{
                            id: variantId,
                            properties: {
                                _one_per_cart: "Yes"
                            }
                        }];
                        const body = {
                            items,
                            sections: cartDrawer.getSectionIdsToRender().join(','),
                            sections_url: BryanAnthonys.pagePath()
                        };

                        BryanAnthonys.cart.add(JSON.stringify(body))
                            .then(resolve)
                            .catch(reject);
                    });
                };

                BryanAnthonys.cart.fetch()
                    .then(cart => removeCartItemsByHandle(cart, this.settings.productHandle))
                    .then(addGiftPackagingToCart)
                    .then(cart => {
                        if (this.dataset.inModal) {
                            // for cart page, if element is in modal, we need to force close the modal before the render,
                            // to eliminate overflow-hidden on body
                            this.closest('modal-dialog').hide('forceClose');
                        }
                        cartDrawer.renderContents(cart);
                    })
                    .catch(handleCartChangeError);
            } else {
                const sections = cartDrawer.getSectionIdsToRender().join(',');

                BryanAnthonys.cart.fetch()
                    .then(cart => removeCartItemsByHandle(cart, this.settings.productHandle, sections))
                    .then(cartInfo => {
                        if (cartInfo.hasCartChanged) {
                            if (this.dataset.inModal) {
                                this.closest('modal-dialog').hide('forceClose');
                            }
                            cartDrawer.renderContents(cartInfo.cart);
                        }
                    })
                    .catch(handleCartChangeError);
            }
        }

        render() {
            let checkboxText = `Add Gift Packaging for ${this.settings.productPrice}`;
            if (this.settings.checkboxText) {
                checkboxText = (this.settings.checkboxText).replace('{price}', this.settings.productPrice);
            }

            const html = `
                <div class="flex justify-content-center align-items-center">
                    <label class="custom-checkbox size-13">
                        <input type="checkbox" value="${this.settings.productVariantId}" ${this.cartHasGiftPackaging() ? 'checked' : ''}>
                        <span class="custom-checkbox__checkmark"></span>
                        <span class="custom-checkbox__text">${checkboxText}</span>
                    </label>
                    
                    <cross-sell-info-modal-opener class="cross-sell-info-modal-opener"
                        data-handle="${config.giftPackaging.productHandle}"
                        data-content-url="/products/${config.giftPackaging.productHandle}?section_id=product-cross-sell-details"
                        ${this.dataset.inModal ? 'data-modal-scope="CartDrawerGiftMessage"' : ''}
                    >
                        <button
                            type="button" class="button-reset cursor-pointer p-2" aria-haspopup="dialog"
                            aria-label="More info about ${BryanAnthonys.escapeHtml(this.settings.productTitle)}"
                        >
                            <svg class="icon icon-error" aria-hidden="true" focusable="false">
                                <use href="#icon-error-black"></use>
                            </svg>
                        </button>
                    </cross-sell-info-modal-opener>
                </div>
            `;

            const elementToRender = this.querySelector('[data-element-to-render]');
            if (elementToRender) {
                elementToRender.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(html));
                this.classList.remove('hidden');
            }
        }

        cartHasGiftPackaging() {
            const giftPackagingItems = getCartLineItemsByHandle(this.cart, this.settings.productHandle);

            return giftPackagingItems.length > 0;
        }
    }

    customElements.define('gift-packaging', GiftPackaging);

    if (config.giftPackaging) {
        BryanAnthonys.cart.addMutator('gift-packaging', (cart) => {
            const giftPackagingItems = cart.items.filter(item => item.handle === config.giftPackaging.productHandle);

            if (!giftPackagingItems.length) {
                return false;
            }

            if (!GiftPackaging.canBeShown(cart)) {
                const sections = cartDrawer.getSectionIdsToRender().join(',');

                removeCartItemsByHandle(cart, config.giftPackaging.productHandle, sections)
                    .then(cartInfo => {
                        if (cartInfo.hasCartChanged) {
                            cartDrawer.renderContents(cartInfo.cart);
                        }
                    });

                return true;
            }

            return false;
        });
    }

    class GiftOptions extends HTMLElement {
        connectedCallback() {
            this.settings = config.giftMessage;

            if (!this.settings.productHandle) {
                console.error('Gift message - product not set');

                return;
            }

            this.cart = BryanAnthonys.cart.getCache();

            if (GiftOptions.canBeShown(this.cart)) {
                this.render();
                cartDrawer.querySelector('cart-items').classList.add('hide-gift-message');
            }
        }

        static canBeShown(cart) {
            const itemsNotBlackListed = cart.items.filter(
                item => config.giftMessage.productTypeBlacklist.indexOf(item.product_type) === -1
            );

            return itemsNotBlackListed.length !== 0;
        }

        cartHasCardIsle() {
            const cardIsleScript = document.querySelector('[data-card-isle-variant-id]');
            if (!cardIsleScript) {
                return false;
            }

            const cardIsleVariantId = parseInt(cardIsleScript.dataset.cardIsleVariantId);
            if (!cardIsleVariantId) {
                return false;
            }

            const CardIsleItems = this.cart.items.filter(item => item.variant_id === cardIsleVariantId);

            return CardIsleItems.length > 0;
        }

        render() {
            const cartHasCardIsle = this.cartHasCardIsle();

            this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <gift-message-button class="${cartHasCardIsle ? 'hidden' : 'left'}"
                    data-product="${this.settings.productHandle}"
                ></gift-message-button>
                <is-gift-checkbox data-label="This is a gift" class="flex align-items-center ${cartHasCardIsle ? 'justify-content-start' : 'justify-content-center'}"
                    data-attribute-name="${this.settings.isGiftAttributeName}" 
                    data-attribute-value="${this.settings.isGiftAttributeValue}"
                ></is-gift-checkbox>
            `));
        }

        cartHasGiftMessage() {
            const giftMessageItems = getCartLineItemsByHandle(this.cart, this.settings.productHandle);

            return giftMessageItems.length > 0;
        }

        cartHasAttribute(attribute, value = null) {
            if (value) {
                return this.cart.attributes[attribute] === value;
            }

            return Object.prototype.hasOwnProperty.call(this.cart.attributes, attribute);
        }

        updateCartAttribute(name, value) {
            return new Promise((resolve, reject) => {
                const attributes = {};
                attributes[name] = value;

                const body = {
                    attributes,
                    sections: cartDrawer.getSectionIdsToRender().join(','),
                    sections_url: BryanAnthonys.pagePath()
                };

                BryanAnthonys.cart.update(JSON.stringify(body))
                    .then(resolve)
                    .catch(reject);
            });
        }

        ensureOrderIsGift() {
            return this.updateCartAttribute(this.settings.isGiftAttributeName, this.settings.isGiftAttributeValue);
        }
    }

    customElements.define('gift-options', GiftOptions);

    class IsGiftCheckbox extends HTMLElement {
        connectedCallback() {
            /**  @type {GiftOptions} */
            this.giftOptions = this.closest('gift-options');
            this.addEventListener('change', this.handleOptionChange.bind(this));

            this.render();
        }

        render() {
            const checked = this.giftOptions.cartHasAttribute(this.dataset.attributeName, this.dataset.attributeValue);

            this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <label class="custom-checkbox custom-checkbox--small size-12">
                    <input type="checkbox" name="${this.dataset.attributeName}" value="${this.dataset.attributeValue}"
                        ${checked ? ' checked' : ''}
                    >
                    <span class="custom-checkbox__checkmark"></span>
                    <span class="custom-checkbox__text">${this.dataset.label}</span>
              </label>
            `));
        }

        handleOptionChange(event) {
            const checkbox = event.target;

            if (checkbox.classList.contains('loading')) {
                checkbox.checked = !checkbox.checked;

                return;
            }

            checkbox.classList.add('loading');

            const cartAttributeValue = checkbox.checked ? this.dataset.attributeValue : null;

            this.giftOptions.updateCartAttribute(this.dataset.attributeName, cartAttributeValue)
                .catch(() => checkbox.checked = !checkbox.checked)
                .finally(() => checkbox.classList.remove('loading'));
        }
    }

    customElements.define('is-gift-checkbox', IsGiftCheckbox);

    class GiftMessagePopup extends HTMLElement {
        constructor() {
            super();
            this.product = null;
            this.productInCart = null;
            this.giftOptions = null;
        }

        static create(product, productInCart, giftOptions) {
            const giftMessagePopup = document.createElement('gift-message-popup');
            giftMessagePopup.product = product;
            giftMessagePopup.productInCart = productInCart;
            /**  @type {GiftOptions} */
            giftMessagePopup.giftOptions = giftOptions;
            giftMessagePopup.giftMessageProp = giftOptions.settings.giftMessageProp;
            giftMessagePopup.renderSettings = {};

            return giftMessagePopup;
        }

        connectedCallback() {
            if (!this.product) {
                console.error('GiftMessagePopup cannot be rendered without a product');

                return;
            }

            this.render();
            this.addEventListener('input', BryanAnthonys.debounce(this.handleTextareaInput, 300));
            this.addEventListener('click', this.handleSave.bind(this));
        }

        render() {
            const product = this.product;

            const variant = product.variants.edges[0].node;
            const variantId = StorefrontCatalog.idFromGid(variant.id);

            this.setRenderSettings(variant.renderSettings);

            const currentGiftMessage = this.productInCart && this.productInCart.properties[this.giftMessageProp]
                ? this.productInCart.properties[this.giftMessageProp]
                : '';

            let cardIsleUpsellHtml = '';
            const cardIsleUpsellTemplate = document.querySelector('[data-card-isle-gift-message-template]');
            if (cardIsleUpsellTemplate) {
                cardIsleUpsellHtml = cardIsleUpsellTemplate.innerHTML;
            }

            let giftPackagingHtml = '';
            if (this.giftOptions.settings.showGiftPackaging) {
                giftPackagingHtml = `
                    <gift-packaging class="gift-packaging hidden" data-in-modal="true">
                        <div class="center mt-3">- OR -</div>
                        <div data-element-to-render></div>
                    </gift-packaging>
                `;
            }

            this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <modal-dialog
                    id="CartDrawerGiftMessage" class="custom-modal custom-modal--centered custom-modal--animate-drop"
                    data-prevent-self-close data-animated="true" data-animation-duration="400" data-unmovable="true"
                    ${!cartDrawer.dataset.onCartPage ? 'data-scope="CartDrawer"' : ''}
                >
                    <div class="custom-modal__content" role="dialog" aria-modal="true" tabindex="-1" aria-label="Add or edit gift message">
                        <div class="custom-modal__content-info">
                            <button data-close-popup id="ModalClose-CartDrawerGiftMessage" aria-label="Close" type="button"
                                class="custom-modal__toggle custom-modal__toggle--borderless custom-modal__toggle--corner custom-modal__toggle--small"
                            >
                                <svg class="icon icon-close" aria-hidden="true" focusable="false">
                                    <use href="#icon-close"/>
                                </svg>
                            </button>
                            
                            <h2 class="h4 size-14 size-16-desktop letter-spacing-2 uppercase block center mb-3">
                                ${product.popupTitle ? product.popupTitle.value : product.title}
                            </h2>
                            
                            ${!this.giftOptions.settings.hidePreview ? '<div class="isolate center overflow-hidden mb-3" data-gift-message-preview-wrapper></div>' : ''}
                            
                            <form method="POST">
                                <label class="center block size-13 size-14-desktop mb-3" for="product-gift-message">${product.formIntro ? product.formIntro.value : ''}</label>
                                <textarea class="gift-message-popup__form-textarea text-area text-area--resize-vertical field__input"
                                    name="product-gift-message" id="product-gift-message"
                                    placeholder="${product.formIntro ? product.formIntro.value : ''}"></textarea>
                                <input type="hidden" name="variant-id" value="${variantId}"/>
                            </form>   
                            
                            <div data-feedback-placeholder></div>
                            
                            <div class="center mt-3">
                                <button class="button button--small uppercase" type="button" data-save>
                                    ${BryanAnthonys.strings.general.save}
                                </button>
                            </div>
                            ${cardIsleUpsellHtml}
                            ${giftPackagingHtml}
                        </div>
                    </div>
                </modal-dialog>
            `));

            this.querySelector('textarea[name="product-gift-message"]').value = currentGiftMessage;

            this.processGiftMessage(currentGiftMessage);

            if (!this.giftOptions.settings.hidePreview) {
                this.generatePreview();
            }
        }

        setRenderSettings(variantRenderSettingsMetafield) {
            this.renderSettings = JSON.parse(variantRenderSettingsMetafield.value);
        }

        handleTextareaInput(event) {
            if (event.target.id === 'product-gift-message') {
                const giftMessage = this.cleanText(event.target);

                this.processGiftMessage(giftMessage);
                if (this.validMessage && !this.giftOptions.settings.hidePreview) {
                    this.changePreview();
                }
            }
        }

        cleanText(textarea) {
            const text = textarea.value.trim();

            const emoticons = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
            let allowedText = text.replace(emoticons, '');

            allowedText = allowedText.replace(/&/g, '').replace(/</g, '').replace(/>/g, '').replace(/"/g, '').replace(/'/g, '');

            if (allowedText != text) {
                textarea.value = allowedText;
                textarea.style.background = '#ffdcdc';
                setTimeout(() => textarea.style.background = '#fff', 500);
            }

            return allowedText;
        }

        processGiftMessage(giftMessage) {
            this.giftMessage = giftMessage;

            this.clearLengthError();

            const fontSize = this.computeFontSize(this.giftMessage);
            if (fontSize) {
                this.validMessage = true;
                this.activeFontSize = fontSize;
            } else {
                this.activeFontSize = this.renderSettings.sizes[this.renderSettings.sizes.length - 1];
                this.validMessage = false;
                this.showLengthError();
            }
        }

        computeFontSize(giftMessage) {
            const lines = giftMessage.split("\n");

            const activeFontSize = this.renderSettings.sizes.find(function (size) {
                let numberOfLines = 0;
                lines.forEach(function (line) {
                    const allWords = line.split(' ');
                    let finalWords = [];
                    allWords.forEach(function (word) {
                        if (word.length > size.characters) {
                            let brokenWords = word.match(new RegExp('.{1,' + size.characters + '}', 'g'));

                            brokenWords.forEach(brokenWord => finalWords.push(brokenWord));

                            return;
                        }

                        finalWords.push(word);
                    });

                    let lineLength = 0;
                    finalWords.forEach(function (finalWord) {
                        lineLength += finalWord.length;

                        if (lineLength > size.characters) {
                            numberOfLines++;
                            lineLength = finalWord.length;
                        }

                        // Add space character after each word
                        lineLength++;
                    });

                    numberOfLines++;
                });

                return numberOfLines <= size.lines;
            });

            return typeof activeFontSize === "undefined" ? null : activeFontSize;
        }

        showLengthError() {
            const errorHtml = `
                <div class="status-banner status-banner--error mt-3" data-feedback-length-selector>
                    The gift message is too long. Please remove some text.
                </div>
            `;

            this.querySelector('[data-feedback-placeholder]').insertAdjacentHTML('afterbegin', errorHtml);
        }

        clearLengthError() {
            this.querySelectorAll('[data-feedback-length-selector]').forEach(el => el.remove());
        }

        generatePreview() {
            const previewWrapperElement = document.querySelector('[data-gift-message-preview-wrapper]');

            let frontImageHtml = '';
            if (this.renderSettings.card.frontImage) {
                const imageUrl = this.renderSettings.card.frontImage;

                frontImageHtml = `
                    <img src="${BryanAnthonys.resizeImage(imageUrl, 700, 500, 'center')}" 
                        width="700" height="500" alt="Card preview front image"
                    />
                `;
            }

            let backImageHtml = '';
            let flipCardButtonHtml = '';
            if (this.renderSettings.card.backImage) {
                const imageUrl = this.renderSettings.card.backImage;

                backImageHtml = `
                    <img src="${BryanAnthonys.resizeImage(imageUrl, 700, 500, 'center')}" 
                        width="700" height="500" alt="Card preview back image"
                    />
                `;

                flipCardButtonHtml = `
                    <button type="button" class="gift-message-card_flip-trigger button button--secondary button--tiny uppercase" data-gift-message-card-flip-trigger >
                        Flip
                    </button>
                `;
            }

            previewWrapperElement.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                ${flipCardButtonHtml}
                <div class="gift-message-card" data-gift-message-card>
                    <div class="gift-message-card-inner">
                        <div class="gift-message-card-front gift-message-popup__preview">
                            <div class="gift-message-popup__preview-image" data-gift-message-preview-image>
                                ${frontImageHtml}
                            </div>
                            <style>
                                @font-face {
                                    font-family: 'CustomFont';
                                    src: url('${this.renderSettings.fontUrl}');
                                    font-weight: normal;
                                    font-style: normal;
                                    font-display: block;
                                }
                            </style>
                            <div class="gift-message-popup__preview-text" data-gift-message-preview-text></div>
                        </div>
                        <div class="gift-message-card-back gift-message-popup__preview-image-back">
                            ${backImageHtml}
                        </div>
                    </div>
                </div>
            `));

            if (this.renderSettings.card.backImage) {
                let button = previewWrapperElement.querySelector('[data-gift-message-card-flip-trigger]');
                if (button) {
                    button.addEventListener('click', () => {
                        previewWrapperElement.querySelector('[data-gift-message-card]').classList.toggle('flipped');
                    });
                }
            }

            this.changePreview();
        }

        changePreview() {
            const previewTextElement = document.querySelector('[data-gift-message-preview-text]');

            const fontSize = this.activeFontSize.size + 'pt';
            previewTextElement.style.fontSize = fontSize;
            previewTextElement.setAttribute('data-active-font-size', fontSize);
            previewTextElement.textContent = this.giftMessage;

            this.adaptPreview(previewTextElement);
        }

        adaptPreview(previewTextElement) {
            // Browser PPI
            const ppi = 96;

            // Set card aspect ratio
            previewTextElement.parentElement.style.aspectRatio = `${this.renderSettings.card.width / this.renderSettings.card.height} / 1`;

            // Calculate and set writable area position
            const yPosition = (100 - (this.renderSettings.card.writableHeight / this.renderSettings.card.height) * 100) / 2;
            const xPosition = (100 - (this.renderSettings.card.writableWidth / this.renderSettings.card.width) * 100) / 2;
            previewTextElement.style.inset = `${yPosition}% ${xPosition}%`;

            // Calculate and set relative font size
            const fontMultiplier = previewTextElement.offsetWidth / (this.renderSettings.card.writableWidth * ppi);
            previewTextElement.style.fontSize = (this.activeFontSize.size * fontMultiplier) + 'pt';
            previewTextElement.style.lineHeight = this.renderSettings.card.lineHeight;
        }

        handleSave(event) {
            if (
                event.target.hasAttribute('data-save')
                && !event.target.hasAttribute('data-loading')
            ) {
                this.save(event.target);
            }
        }

        save(button) {
            const formData = new FormData(this.querySelector('form'));
            const giftMessage = formData.get('product-gift-message').trim();

            if (!this.validMessage) {
                return;
            }

            button.setAttribute('data-loading', '');
            button.classList.add('loading');

            const handleCartChangeError = error => {
                console.error('Error when saving gift messge', error);
                button.removeAttribute('data-loading');
                button.classList.remove('loading');
                this.querySelector('[data-feedback-placeholder]').innerHTML = `
                    <div class="status-banner status-banner--error mt-3">
                        An error occurred. Please refresh the page and try again. 
                        We apologize for the inconvenience. 
                        If the problem persists, please get in touch with customer service.
                    </div>
                `;
            };

            if (giftMessage) {
                const addGiftMessageToCart = () => {
                    const properties = {};
                    properties[this.giftMessageProp] = giftMessage;
                    const items = [{
                        id: formData.get('variant-id'),
                        properties
                    }];

                    return BryanAnthonys.cart.add(JSON.stringify({items}), 'gift-message');
                };
                const ensureOrderIsGift = () => this.giftOptions.ensureOrderIsGift();

                BryanAnthonys.cart.fetch()
                    .then(cart => removeCartItemsByHandle(cart, this.product.handle))
                    .then(addGiftMessageToCart)
                    .then(ensureOrderIsGift)
                    .then(cart => {
                        this.querySelector('modal-dialog').hide('forceClose');
                        cartDrawer.renderContents(cart);
                    })
                    .catch(handleCartChangeError);
            } else {
                const sections = cartDrawer.getSectionIdsToRender().join(',');
                BryanAnthonys.cart.fetch()
                    .then(cart => removeCartItemsByHandle(cart, this.product.handle, sections))
                    .then(cartInfo => {
                        this.querySelector('modal-dialog').hide('forceClose');
                        if (cartInfo.hasCartChanged) {
                            cartDrawer.renderContents(cartInfo.cart);
                        }
                    })
                    .catch(handleCartChangeError);
            }
        }
    }

    customElements.define('gift-message-popup', GiftMessagePopup);

    class GiftMessageButton extends HTMLElement {
        connectedCallback() {
            /**  @type {GiftOptions} */
            this.giftOptions = this.closest('gift-options');

            const giftMessageItems = getCartLineItemsByHandle(this.giftOptions.cart, this.dataset.product);

            this.giftMessageItem = giftMessageItems[0];

            this.addEventListener('click', event => {
                const button = event.target;
                if (button.classList.contains('loading')) {
                    return;
                }
                button.classList.add('loading');
                BryanAnthonys.loadScript('storefront-catalog', {callback: () => this.handleClick(event)});
            });

            this.render();
        }

        render() {
            this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <button type="button" class="p-0 link size-12 ${this.giftMessageItem ? 'success' : 'text-subdued'}" aria-haspopup="dialog">
                    ${this.giftMessageItem ? 'Edit gift message' : 'Add gift message'}
                </button> 
            `));
        }

        handleClick(event) {
            const button = event.target;

            const query = `{
                productByHandle(handle: "${this.dataset.product}") {
                    title
                    handle
                    featuredImage {
                        url
                        altText
                        width
                        height
                    }
                    variants(first: 100) {
                        edges {
                            node {
                                id
                                title,
                                image {
                                    url
                                    altText
                                    width
                                    height
                                }
                                renderSettings: metafield(namespace: "gift_message", key: "render_settings") {
                                    value
                                }
                            }
                        }
                    }
                    popupTitle: metafield(namespace: "gift_message", key: "popup_title") {
                        value
                    }
                    formIntro: metafield(namespace: "gift_message", key: "form_intro") {
                        value
                    }
                }
            }`;

            const giftOptionsElement = document.querySelector('gift-options');

            StorefrontCatalog.executeGraphQuery(query)
                .then(response => response.json())
                .then(response => {
                    if (response.data.productByHandle) {
                        this.renderPopup(response.data.productByHandle);
                        document.getElementById('CartDrawerGiftMessage').show(this);
                    } else {
                        giftOptionsElement.remove();
                    }
                })
                .catch(error => {
                    giftOptionsElement.remove();
                    console.error(error);
                    alert('An error occurred, please try refreshing the page');
                })
                .finally(() => {
                    button.classList.remove('loading');
                });
        }

        renderPopup(product) {
            const popup = GiftMessagePopup.create(product, this.giftMessageItem, this.giftOptions);

            const oldPopup = this.giftOptions.querySelector('gift-message-popup');
            if (oldPopup) {
                oldPopup.remove();
            }

            this.giftOptions.appendChild(popup);
        }
    }

    customElements.define('gift-message-button', GiftMessageButton);

    if (config.giftMessage) {
        BryanAnthonys.cart.addMutator('gift-message', (cart) => {
            const giftMessageItems = cart.items.filter(item => item.handle === config.giftMessage.productHandle);

            if (!giftMessageItems.length) {
                return false;
            }

            if (!GiftOptions.canBeShown(cart) || giftMessageItems.length > 1) {
                const sections = cartDrawer.getSectionIdsToRender().join(',');

                removeCartItemsByHandle(cart, config.giftMessage.productHandle, sections)
                    .then(cartInfo => {
                        if (cartInfo.hasCartChanged) {
                            cartDrawer.renderContents(cartInfo.cart);
                        }
                    });

                return true;
            }

            return false;
        });
    }
})();